import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FDHero } from '../components/fat-dissolving/FDHero';
import { FDWhatIs } from '../components/fat-dissolving/FDWhatIs';
import { FDAgingFat } from '../components/fat-dissolving/FDAgingFat';
import { FDTreatments } from '../components/fat-dissolving/FDTreatments';
import { FDFAQ } from '../components/fat-dissolving/FDFAQ';
import { FDWhyChoose } from '../components/fat-dissolving/FDWhyChoose';
export function FatDissolvingPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2515">
      <Navigation data-id="element-2516" />
      <main data-id="element-2517">
        <FDHero data-id="element-2518" />
        <FDWhatIs data-id="element-2519" />
        <FDAgingFat data-id="element-2520" />
        <FDTreatments data-id="element-2521" />
        <FDFAQ data-id="element-2522" />
        <FDWhyChoose data-id="element-2523" />
      </main>
      <Footer data-id="element-2524" />
    </div>;
}